import React from 'react';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import FastForwardIcon from '@material-ui/icons/FastForward';
import { IconButton, Typography } from '@material-ui/core';

import {TimeTravelContext} from './context';

import './styles.scss';
import {Tooltip} from "../Tooltip";

const TimeTravel = () => {
  const {date, setDate} = React.useContext(TimeTravelContext);

  function moveYearBackward() {
    setDate(date.subtract(1, 'year').endOf('quarter'));
  }

  function moveQuarterBackward() {
    setDate(date.subtract(1, 'quarter').endOf('quarter'));
  }

  function moveQuarterForward() {
    setDate(date.add(1, 'quarter').endOf('quarter'));
  }

  function moveYearForward() {
    setDate(date.add(1, 'year').endOf('quarter'));
  }

  return (
    <div className="d-flex flex-column align-items-center" style={{marginTop: -16}}>
      <div className='d-flex flex-row'>
        <Typography className='metricLabel text-uppercase'>AT THE END OF</Typography>
        <Tooltip title={
          "The data in this dashboard will be defaulted to the last date of the previous quarter. " +
          "If the date is moved to the current quarter, " +
          "the calculations will run as of the last date of the current quarter accounting for any future vesting."
        }/>
      </div>
      <div
        className="btn-group date-selector d-flex align-items-center bg-white"
        style={{
          height: 36,
          border: '1px solid #f0f1f1',
        }}
      >
        <IconButton className="doubleRight" onClick={moveYearBackward}>
          <FastForwardIcon
            fontSize="small"
            style={{ transform: 'rotateZ(180deg)' }}
          />
        </IconButton>
        <IconButton className="singleArrow" onClick={moveQuarterBackward}>
          <PlayArrowIcon style={{ transform: 'rotateZ(180deg)' }} />
        </IconButton>

        <button id="periodDate" className="btn bg-white qdate" style={{width: 80}}>
          {date.format('[Q]Q YYYY')}
        </button>
        <IconButton
          title="Previous Period"
          className="singleArrow"
          onClick={moveQuarterForward}
        >
          <PlayArrowIcon />
        </IconButton>
        <IconButton className="doubleLeft" onClick={moveYearForward}>
          <FastForwardIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
};

export default TimeTravel;
